<template>
  <transition-group :name="transition" tag="div" class="content-wrap content-wrap--bigger">

    <div v-if="pageLinks.length" key="infocenterMenu">
      <kapp-header id="mainHeader" key="header" :subTitle="this.contentTitle"></kapp-header>

      <ul class="list list--chapter">
          <template v-for="(article,idx) in pageLinks">
              <li class="list-item box has-link" v-if="idx == 0" v-bind:key="idx">
                  <router-link :to="{name: 'AktuellesListe'}">Schwarzes Brett
                      <i class="icon icon-weiter"></i></router-link>
              </li>
            <li class="list-item box" v-bind:key="idx" :class="{'has-link' : article.slug}">
              <router-link :to="{ name : 'Infocenter', params : { slug : article.uid + article.slug.replaceAll('/','_') }}" v-if="article.slug">{{article.title}} <i class="icon icon-weiter"></i></router-link>
              <span v-if="!article.slug">{{ article.title }}</span>
            </li>

          </template>

      </ul>
    </div>

    <div v-else key="infocenterContent">

      <kapp-header id="mainHeader" key="header" :subTitle="this.contentTitle"></kapp-header>

      <template v-if="content.length">
        <!--<master-block v-for="(contentBlock,uid) in content" :data="contentBlock"
                      :key="uid + '_' + contentBlock.title"></master-block>-->
          <div class="content-block" v-for="(contentBlock,uid) in content" :key="uid + '_' + contentBlock.title" :class="'content-block--' + contentBlock.ctype">
              <component :block="contentBlock" :is="contentBlock.ctype" v-if="contentBlock.ctype !== 'list'" ></component>
              <component :block="contentBlock" :is="contentBlock.listType" v-else></component>
          </div>
      </template>

      <template v-else-if="places">
        <kapp-place :places="places" :categories="placeCategories"></kapp-place>
      </template>

      <template v-else-if="this.$route.params.slug === 'social'">
        <kapp-social class="content"></kapp-social>
      </template>

      <template v-else-if="articles.length">
        <kapp-articleBlock v-for="article in articles" :available_categories="articleCategories"
                           :article="article"
                           v-bind:key="'uid-' + article.uid"
                           :uid="article.uid"
        />
      </template>

    </div>
  </transition-group>
</template>

<script>
	import debounce from 'lodash.debounce';
	import api, { ApiDefaults } from "../utils/api_call";
	import KappGallery from "../components/subparts/KappGallery";
	import KappPlace from "../components/blocks/KappPlace";
	import Header from "../components/layouts/Header";
	import KappSocialMedia from './KappSocialMedia';
	import KappNews from '../components/blocks/KappNews';
    import BlockDefault from '../components/blocks/BlockDefault';
    import BlockHeader from '../components/blocks/BlockHeader';
    import FragebogenWrap from '../components/subparts/FragebogenWrap';

	export default {
		name: "KappInfocenter",
		components: {
			'kapp-gallery': KappGallery,
			'kapp-place': KappPlace,
			'kapp-header': Header,
			'kapp-social': KappSocialMedia,
			'kapp-articleBlock': KappNews,
            'textmedia' : BlockDefault,
            'header' : BlockHeader,
            'c3barometer_fragebogen': FragebogenWrap
		},
		methods: {
			fetchData: debounce(function () {

				let sourceId = 4;

				if ( this.$route.params.slug !== 'alles' ) {
					sourceId = this.$route.params.slug.split('_');
					sourceId = sourceId[0];
				}

				if ( this.$route.params.slug !== 'social' ) {

					let apiParams = Object.assign({}, ApiDefaults, {params: {id: sourceId}});
					api(apiParams)
						.then(response => {
							if ( response.status === 200  ) {
								this.pageLinks = false;
								this.content = false;
								this.places = false;
								this.articles = false;
// console.dir(response.data);
								if ( response.data.hasOwnProperty('menu') ) {
									let pageLinks = response.data.menu.pages;
									this.pageLinks = pageLinks;
								}

								else if ( response.data.hasOwnProperty('ttContent') ) {
									let content = response.data.ttContent.content;
									this.content = content;
								}

                                else if ( response.data.hasOwnProperty('fragen') ) {
                                    let content = response.data.content;
                                    this.content = content;
                                }

								else if ( response.data.hasOwnProperty('places') ) {
									this.places = response.data.places;
									this.placeCategories = response.data.categories || [];

								}

								else if ( response.data.hasOwnProperty('news') ) {
									this.articles = response.data.news.content.map(( item ) => {

										                        item.categories = [ parseInt(item.categories) ];
										                        item.visible = true;

										                        return item;
									                        })
									                        .sort(( a, b ) => {
										                        return b.datetime - a.datetime;
									                        });

									this.articleCategories = Object.values(response.data.news.categories);

								}


								if ( response.data.page.pageTitle !== 'Infocenter' ) {
									this.contentTitle = response.data.page.pageTitle;
								}
								else {
									this.contentTitle = '';
								}
							}
						})
						.catch(e => {
							// console.dir( e );
						});
				}
				else {
					this.pageLinks = [];
				}
			}, 125),
			galleryImages: function ( images ) {

				if ( images.length > 0 ) {
					let gallery = this.content.images;
					return gallery;
				}

				return [];
			}
		},

		data() {

			return {
				pageLinks: false,
				content: false,
				places: false,
				articles: false,
				articleCategories: [],
				placeCategories: [],
				pageTitle: 'Infocenter',
				contentTitle: '',
				transition: ''
			};
		},
		computed: {},
		mounted() {
			// this.fetchData();

		},
		beforeMount() {
			this.fetchData('');
		},
		watch: {
			'$route': function ( to, from ) {
				this.fetchData('');

				if ( from.name === 'Infocenter' ) {
					if ( from.params.slug === 'alles' ) {
						this.transition = 'slide-left';
					}
					else {
						this.transition = 'slide-right';
					}
				}
			},
			'$route.params.slug': function ( to, from ) {

			}
		}
	};
</script>

<style scoped>

  .slide-left-enter-to, .slide-left-enter,
  .slide-left-leave-to, .slide-left-leave,
  .slide-right-enter-to, .slide-right-enter,
  .slide-right-leave-to, .slide-right-leave {
    position: absolute;
    top: 0;
    padding: 107px 30px 0;
    left: 0;
    right: 0;
    height: 100vh;
    background: inherit; /* radial-gradient(ellipse closest-side, #36404d, transparent, 200%, transparent);*/
    will-change: transform;
  }

  .slide-left-enter-active,
  .slide-right-leave-active {
    z-index: 40;
  }

  .slide-left-enter-active,
  .slide-left-leave-active,
  .slide-right-enter-active,
  .slide-right-leave-active {
    /*animation-duration: 35s;*/
    /*animation-timing-function: ease-out;*/
  }
</style>



// WEBPACK FOOTER //
// src/pages/KappInfocenter.vue